export const TEST_ID = 'exportProgressList';

export const STEPS = [
    { stepNumber: 1, translationKey: 'stepSummary' as const },
    { stepNumber: 2, translationKey: 'stepMapLayer' as const },
    { stepNumber: 3, translationKey: 'stepFileResource' as const },
    { stepNumber: 4, translationKey: 'stepUpload' as const }
];
